import * as React from 'react';

import {Button} from 'shells/button/button';
// @ts-expect-error - imported from .js/.jsx file
import {ExternalLinkIcon} from 'shells/icon/svg/external-link-icon';
import {UpgradePillButton} from 'shells/limits/upgrade-pill-button';

import styles from '../security-page.module.css';

type Props = {
    canSetup: boolean;
    isConfigured: boolean;
    canConfigureDirectorySync: boolean;
    setIsFeatureGateModalOpen: (isOpen: boolean) => void;
    handleOpenAdminPortal: () => void;
    disableRef: {
        current: HTMLElement | null | undefined;
    };
    setIsDisableDirectorySyncConfirmationOpen: (isOpen: boolean) => void;
};

export function DirectorySyncConfigureButtons(props: Props) {
    if (!props.canSetup) {
        return (
            <div className='flex flex-grow justify-end'>
                <UpgradePillButton
                    onClick={() => props.setIsFeatureGateModalOpen(true)}
                    size='small'
                />
            </div>
        );
    } else if (props.isConfigured) {
        return (
            <div className='flex gap-8 flex-grow justify-end'>
                <Button variant='primary' size='small' onClick={props.handleOpenAdminPortal}>
                    <div className='flex align-center gap-6'>
                        <div className={styles['sso-icon-in-button']}>
                            <ExternalLinkIcon size={14} />
                        </div>
                        Manage
                    </div>
                </Button>
                {/* @ts-expect-error */}
                <div ref={props.disableRef}>
                    <Button
                        variant='secondary'
                        size='small'
                        onClick={() => props.setIsDisableDirectorySyncConfirmationOpen(true)}
                    >
                        Disable
                    </Button>
                </div>
            </div>
        );
    } else if (!props.isConfigured) {
        return (
            <div className='flex flex-grow justify-end'>
                <Button
                    variant='primary'
                    size='small'
                    disabled={!props.canConfigureDirectorySync}
                    tooltipText={!props.canConfigureDirectorySync ? 'Configure single sign-on' : ''}
                    onClick={props.handleOpenAdminPortal}
                >
                    <div className='flex align-center gap-6'>
                        <div className={styles['sso-icon-in-button']}>
                            <ExternalLinkIcon size={14} />
                        </div>
                        Configure
                    </div>
                </Button>
            </div>
        );
    } else {
        return null;
    }
}
